var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"not-found-page",style:(_vm.inlineStyles)},[_c('h1',{staticClass:"not-found-page__title"},[_vm._v("Кажется, вы затерялись в звездах")]),_c('router-link',{staticClass:"not-found-page__link",attrs:{"to":{ name: 'root' }}},[_vm._v("Вернуться на главную")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }